<!-- 店铺档案 -->
<template>
  <div id="storeFile" name="storeFile">
    <div class="infoBox">
      <!-- 企业信息 -->
      <div class="enterpriseInfo">
        <div class="headline"><svg-icon icon-class="enter-info" /> 企业信息</div>
        <ul>
          <li><span>企业名称</span>{{ renderData.FProviderUnitName }}</li>
          <li><span>信用代码</span>{{ renderData.FProviderUnitCode }}</li>
          <li><span>企业地址</span>{{ renderData.FAddress }}</li>
        </ul>
      </div>
      <!-- 企业信息 end -->

      <!-- 证书信息 -->
      <div class="certificateInfo">
        <div class="headline"><svg-icon icon-class="certificate" /> 证书信息</div>
        <ul class="bookImg-box">
          <li v-for="(item, index) in bookImgs" :key="index">
            <el-image v-if="item.imgUrl" :src="item.imgUrl" :preview-src-list="item.imgList" />
            <div v-else class="noImage">
              暂无图片
            </div>
            <p>{{ item.label }}</p>
          </li>
        </ul>
      </div>
      <!-- 证书信息 end -->
    </div>

    <!-- 实地考察 -->
    <div class="inspect" style="padding-top: 0;">
      <!-- 实地考察文字 -->
      <div class="paramBox">
        <div style="display:flex;" class="headline">
          <svg-icon style="font-size:100px;" icon-class="investigate" />
          <div style="line-height:105px;margin-left:5px;">
            实地考察
          </div>
        </div>
        <ul>
          <li v-for="(t,i) in contentArr" :key="i"><span>{{ t.FTitle }}</span>{{ t.FContent }}</li>
          <!-- <li><span>主营品牌</span>{{ inspectData.mainBrand }}</li>
          <li><span>员工人数</span>{{ inspectData.staffNum }}</li>
          <li><span>经营场所面积</span>{{ inspectData.areg }}</li>
          <li><span>生产设备数量</span> {{ inspectData.equipmentNum }}</li> -->
        </ul>
      </div>
      <!-- 实地考察文字 end -->

      <!-- 轮播图 -->
      <div v-if="imgArr.length" class="swiperImg">
        <div class="swiperBox">
          <el-carousel height="280px" arrow="never">
            <el-carousel-item
              v-for="(item, index) in imgArr"
              :key="index"
            >
              <el-image :src="item.FImagePath" :preview-src-list="[item.FImagePath]">
                <div slot="error" style="width:100%;height:100%;" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="data-source">
            <span>数据来源</span>
            实达实平台工作人员实地考察上传
          </div>
        </div>
      </div>
      <!-- 轮播图 end -->
    </div>
    <!-- 实地考察 end -->

    <!-- 查看大图box -->
    <div v-if="bigBoxShow" class="bigImgBox">
      <span class="closeImg el-icon-circle-close" @click="closeBigBoxEvent" />
      <img :src="bigImgUrl" alt="">
    </div>
    <!-- 查看大图结束 -->
  </div>
</template>
<script>
import { queryStoreTitleTypeInfo } from '@/api/shop.js'
export default {
  data() {
    return {
      imgArr: [],
      contentArr: [],
      renderData: {
        FAddress: '',
        FAgentLicenseImg: '',
        FLevelName: '',
        FLicenseImagePath: '',
        FProviderUnitCode: '',
        FProviderUnitName: '',
        FSpecialLicenseImg: '',
        WebAreaFId: null,
        mallstoreFID: null,
        providerunitFID: null,
        FieldTrips: []
      },
      storeInfoData: {
        // 企业信息数据
        storeName: '衢州市飞宇电缆设备有限公司',
        creditCode: 'SDHFJFJ132545',
        storeAddress: '衢州市柯城区衢化路109号'
      },

      inspectData: {
        // 实地考察数据
        mainProduct: '电缆线,各类电线',
        mainBrand: 'YJJ',
        staffNum: '20',
        areg: '3000平方米',
        equipmentNum: '20'
      },

      bookImgs: [
        // 证书图片集合
        // require('@/assets/images/certificate1.png')
        // require('@/assets/images/certificate2.png')
        // require('@/assets/images/certificate3.png')
        {
          imgUrl: '',
          label: '营业执照',
          imgList: []
        },
        {
          imgUrl: '',
          label: '特殊行业许可证',
          imgList: []
        },
        {
          imgUrl: '',
          label: '代理许可证',
          imgList: []
        }
      ],

      bookSrcList: [
        // 证书大图预览url集合
        require('@/assets/images/certificate1.png'),
        require('@/assets/images/certificate2.png'),
        require('@/assets/images/certificate3.png')
      ],

      bigImgUrl: '', // 查看大图rul
      bigBoxShow: false, // 大图盒子显示与隐藏

      swiperImgUrlList:
        // 轮播图url集合
        [
          require('@/assets/images/swiperImg1.png'),
          'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg0.pchouse.com.cn%2Fpchouse%2F2107%2F15%2F3166623_2.jpg&refer=http%3A%2F%2Fimg0.pchouse.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1651601067&t=a58e054f141ba51df16f3ca1ec59628a',
          'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.zhimg.com%2Fv2-7c08db24c233fc2e7cd19fb710081bc4_1440w.jpg%3Fsource%3D172ae18b&refer=http%3A%2F%2Fpic1.zhimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1651601067&t=e7d3003714300e69095af7b079af4490',
          'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.cnzhengmu.com%2Fuploads%2Ffile%2F20210527%2Fimage154452702466.png&refer=http%3A%2F%2Fwww.cnzhengmu.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1651601067&t=a4a81b4de18587abf4c7ccf538552e55'
        ]
    }
  },

  beforeCreate() {
  },

  created() {
    this.onSearch()
  },
  methods: {
    onSearch() {
      const { fid, forder, storeId } = this.$route.query
      const params = new URLSearchParams()
      params.append('FMallStoreId', storeId)
      params.append('StorePageNavigationFID', fid)
      params.append('StorePageNavigationFOrder', forder)
      queryStoreTitleTypeInfo(params)
        .then(res => {
          this.renderData = res.data
          this.bookImgs[0].imgUrl = res.data.FLicenseImagePath ? res.data.FLicenseImagePath.split(',')[0] : ''
          this.bookImgs[0].imgList = res.data.FLicenseImagePath.split(',')
          this.bookImgs[1].imgUrl = res.data.FSpecialLicenseImg ? res.data.FSpecialLicenseImg.split(',')[0] : ''
          this.bookImgs[1].imgList = res.data.FSpecialLicenseImg.split(',')
          this.bookImgs[2].imgUrl = res.data.FAgentLicenseImg ? res.data.FAgentLicenseImg.split(',')[0] : ''
          this.bookImgs[2].imgList = res.data.FAgentLicenseImg.split(',')
          this.imgArr = []
          this.contentArr = []
          this.renderData.FieldTrips.forEach(i => {
            if (i.FDataType === 1) {
              this.contentArr.push(i)
            }
            if (i.FDataType === 2) {
              this.imgArr.push(i)
            }
          })
        })
    },
    setBigImg(src) {
      this.bigImgUrl = src
      this.bigBoxShow = true
    },
    // 关闭查看大图盒子事件
    closeBigBoxEvent() {
      document.body.style.overflow = 'auto'
      this.bigImgUrl = ''
      this.bigBoxShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
#storeFile {
  width: 100%;
  background: #f5f5f5;
  padding: 20px 10px;
  height: 100%;
  // overflow: auto;
  .noImage {
      width: 120px;
      height: 160px;
      line-height: 160px;
      text-align: center;
      background: #f5f7fa;
      font-size: 14px;
  }
  .bookImg-box {
      position: relative;
      left: 13%;
      :last-child {
          margin-right: 0 !important;
      }
  }
  .infoBox,
  .inspect {
    display: flex;
    padding: 30px 0;
    background: #fff;
    // 企业信息,证书信息,店铺考察CSS
    .headline {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      margin-bottom: 26px;
    }
    .enterpriseInfo,
    .paramBox {
      //  企业信息，实地考察二级参数CSS
      li {
        font-size: 14px;
        color: #666666;
        margin-bottom: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        span {
          display: inline-block;
          width: 120px;
          color: #999999;
        }
      }
    }
  }

  .infoBox {
    margin-bottom: 10px;
    height: 286px;
    .enterpriseInfo,
    .certificateInfo {
      padding-left: 20px;
    }

    .enterpriseInfo {
      //   企业信息CSS
      width: 50%;
      height: 230px;
      border-right: 1px solid rgba($color: #eeeeee, $alpha: 1);
    }

    .certificateInfo {
      //   证书信息CSS
      width: 50%;
      height: 286px;
      ul {
        width: 100%;
        display: flex;
        li {
          margin-right: 20px;
          // 证书图片CSS
          .el-image {
            width: 120px;
            height: 160px;
          }
          // 图片文字标注CSS
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            text-align: center;
          }
        }
      }
    }
  }
  .data-source{
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    text-align: right;
  }
  .inspect {
    //   实地考察CSS
    min-height: 408px;

    .paramBox {
      // 左侧文字CSS
      width: 50%;
      padding-left: 20px;
    }

    .swiperImg {
      // 右侧轮播图CSS
      width: 50%;
      position: relative;
    }
  }

  .bigImgBox {
    //大图盒子css
    width: 100%;
    height: 100%;
    padding: 20px;
    background: rgba($color: #000000, $alpha: 0.5);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    // overflow: auto;
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .closeImg {
      font-size: 40px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }

  .el-image {
    // 光标变手指
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
}
#storeFile {
  .swiperBox {
    // 轮播图样式
    width: 500px;
    .el-carousel {
      width: 100%;
      margin-bottom: 10px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    position: absolute;
    top: 42px;
    right: 22px;

    .el-carousel__button {
      // 轮播图圆点样式
      background: #000;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50% !important;
    }
  }
}
</style>
